module.exports = __webpack_public_path__ + "img/wind-arrow.860bc978.svg";